/* eslint-disable @typescript-eslint/no-require-imports */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import {Image, Text, View} from 'react-native';
import { formsStyles } from '../formStyles';
import { buttonsStyles } from '../../Button/boutonStyle';
import Dropzone from 'react-dropzone';

interface IProps {
  callback: any;
  type: string;
  label?: string;
}

export function FilePickerWeb({callback, type, label}: IProps) {

  const handleDrop = (acceptedFiles: any) => {
    callback(acceptedFiles);
  };
  
  return (
    <div>
      {label && (
        <Text style={[formsStyles.labelStyle]}>
          {label} {<Text>*</Text>} :
        </Text>
      )}
      <Dropzone
        onDrop={handleDrop}
        accept={{
          'image/png': ['.png'],
          'image/jpeg': ['.jpeg', '.jpg'],
          'image/svg+xml': ['.svg'],
        }}>
        {({getRootProps, getInputProps}) => (
          <div {...getRootProps({className: 'dropzone'})}>
            <input {...getInputProps()} />
            {type === 'fileLabeled' && (
              <View style={[buttonsStyles.ButtonGreen, {marginLeft: 0}]}>
                <Text style={buttonsStyles.ButtonGreenTxt}>
                  Importer une photo
                </Text>
                <Image
                  source={require('../../../../ressources/images/image_ph.png')}
                  style={buttonsStyles.ButtonGreenImg}
                />
              </View>
            )}
            {type === 'fileLabeledNotext' && (
              <View style={[buttonsStyles.ButtonGreen, {marginLeft: 0}]}>
                <Text style={buttonsStyles.ButtonGreenTxt}>Modifier</Text>
                <Image
                  source={require('../../../../ressources/images/image_ph.png')}
                  style={buttonsStyles.ButtonGreenImg}
                />
              </View>
            )}
            {type === 'fileNoLabel' && (
              <View style={buttonsStyles.ButtonGreenNoLabel}>
                <Image
                  source={require('../../../../ressources/images/attachment.png')}
                  style={buttonsStyles.ButtonGreenImg}
                />
              </View>
            )}
          </div>
        )}
      </Dropzone>
    </div>
  );
}
